module.exports = __webpack_public_path__ + "static/img/right.4ce9e576.png";